import { TimePeriodUnsegmentedVizViews } from '../types';
import { timePeriodUnsegmentedBarChartViewConfig } from './bar-chart/view-config';
import { timePeriodUnsegmentedPieChartViewConfig } from './pie-chart/view-config';

export const timePeriodUnsegmentedViewConfigs = [
  {
    name: TimePeriodUnsegmentedVizViews.BAR_CHART,
    viewConfig: timePeriodUnsegmentedBarChartViewConfig,
  },
  {
    name: TimePeriodUnsegmentedVizViews.PIE_CHART,
    viewConfig: timePeriodUnsegmentedPieChartViewConfig,
  },
];
